import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, HostListener, Input, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Observable } from 'rxjs';
import { environment } from '@env';
import { INavbarLink } from '@shared/models/interfaces/navbar-link.interface';
import { FormErrorsDebugService } from 'app/features/revisione53/core/services/form-errors-debug.service';

@Component({
    selector: 'button[app-validation-errors-btn]',
    templateUrl: './validation-errors-btn.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ValidationErrorsBtnComponent implements OnDestroy {
    @Input() sectionTitle = '';
    @Input() form?: FormGroup;
    @Input() subLinks?: INavbarLink[];
    @Input() isValid$?: Observable<boolean>;
    /** Forces the loading (disabled) state while a bulk operation is being validated. */
    @Input() loading = false;

    private readonly asyncPipe: AsyncPipe;

    @HostBinding('attr.type') readonly type = 'button';
    @HostBinding('class.btn-outline-secondary') get loadingClass(): boolean {
        return this.isLoading;
    }
    @HostBinding('class.btn-outline-primary') get validClass(): boolean {
        return !this.isLoading && this.isValid;
    }
    @HostBinding('class.btn-outline-danger') get invalidClass(): boolean {
        return !this.isLoading && !this.isValid;
    }
    @HostBinding('disabled') get isDisabled(): boolean {
        return this.isLoading;
    }
    @HostBinding('hidden') get isHidden(): boolean {
        return !environment.showValidationBtnErrors || (!this.form && !this.subLinks?.length);
    }
    @HostBinding('attr.title') get tooltip(): string {
        if (this.isLoading) return 'Validazione in corso…';
        return this.isValid ? 'Nessun errore di validazione' : 'Mostra errori di validazione';
    }

    constructor(private debug: FormErrorsDebugService, cdr: ChangeDetectorRef) {
        this.asyncPipe = new AsyncPipe(cdr);
    }

    get isLoading(): boolean {
        return this.loading || this.state === null;
    }

    get isValid(): boolean {
        return this.state === true;
    }

    ngOnDestroy(): void {
        this.asyncPipe.ngOnDestroy();
    }

    @HostListener('click', ['$event'])
    open(event: Event): void {
        event.stopPropagation();
        event.preventDefault();
        if (this.subLinks?.length) {
            this.debug.showAggregate(this.sectionTitle, this.subLinks);
        } else {
            this.debug.show(this.sectionTitle, this.form);
        }
    }

    private get state(): boolean | null {
        return this.asyncPipe.transform(this.isValid$) ?? null;
    }
}
